import { gql } from '@apollo/client'
import { getCurrentDateTimeForApi } from 'utils/dateutil'
import moment from 'moment'
import { consoleLog } from 'utils/Logger'
import { GetAllRevisitStatuses, REVISIT_STATUS } from 'pages/revisit/util'

export const getCurrentDate = () => {
  consoleLog('query date=' + moment().format('YYYY-MM-DDTHH:mm:ss[Z]'))

  return moment().format('YYYY-MM-DDTHH:mm').toString()
  // return '2023-07-25T16:23'
}

export const ATTENDANCE_AVAILABILITY = gql`
  query AttendanceAvailability {
    attendanceAvailability {
      enabled
    }
  }
`

export const ATTENDANCE_STATUS = gql`
  query AttendanceStatus {
    attendanceStatus {
      status
      sessionId
      attendanceDate
      checkInAt
      checkOutAt
      totalWorkSeconds
      canCheckIn
      canCheckOut
      canUndoCheckOut
      undoCheckOutExpiresAt
      showAutoCheckoutWarning
      autoCheckoutWarningMessage
      autoCheckoutWarningSessionId
    }
  }
`

export const ATTENDANCE_MY_ATTENDANCE = gql`
  query AttendanceMyAttendance($input: AttendanceMyAttendanceInput) {
    attendanceMyAttendance(input: $input) {
      selectedEmployee {
        userId
        employeeId
        name
        isSelf
      }
      accessibleUsers {
        userId
        employeeId
        name
        isSelf
      }
      dateFilter
      fromDate
      toDate
      managerEditEnabled
      approvalFlowEnabled
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      rows {
        attendanceDate
        dayOfWeek
        sessionId
        employeeId
        employeeName
        status
        checkInAt
        checkOutAt
        checkOutMode
        totalWorkSeconds
        sessions {
          sessionId
          status
          checkInAt
          checkOutAt
          checkOutMode
          totalWorkSeconds
          isStaleOpenSession
        }
        isStaleOpenSession
        approvalStatus
        approvalPeriodStartDate
        approvalPeriodEndDate
        approvalDeadlineDate
        canManagerEdit
      }
    }
  }
`

export const ATTENDANCE_MANAGER_APPROVAL_PERIODS = gql`
  query AttendanceManagerApprovalPeriods($input: AttendanceManagerApprovalPeriodsInput) {
    attendanceManagerApprovalPeriods(input: $input) {
      approvalFlowEnabled
      managerEmployeeId
      accessibleUsers {
        userId
        employeeId
        name
        isSelf
      }
      periods {
        employeeId
        employeeName
        periodStartDate
        periodEndDate
        periodNumber
        approvalDeadlineDate
        status
        approvedAt
        approvedByUserId
        approvedByEmployeeId
        autoApprovedAt
        canApprove
      }
    }
  }
`

export const GET_ALL_LEADS_COUNT = gql`
  query getAllLeadsCount {
    deploymentProgressLeads: opportunityList(
      input: { filters: { status: [DEPLOYMENT_APPROVED,DEPLOYMENT_COMPLETED] }, pagination: { page: 0, size: 1000 } }
    ) {
      count
    }
    inReviewLeads: opportunityList(
      input: {
        filters: { status: [ DEPLOYMENT_REQUESTED,PO_ACTIVATION_REQUESTED] }
        pagination: { page: 0, size: 1000 }
      }
    ) {
      count
    }
    newLeads: opportunityList(
      input: {
        filters: { status: [INITIATED, PRICING_SUBMITTED, PRICING_APPROVED,PO_ACTIVATION_APPROVED] }
        pagination: { page: 0, size: 1000 }
      }
    ) {
      count
    }
    assigned: leadList(
      input: {
        filters: {
          isAssigned: true,
          leadStatuses: [NEW, OPEN_CONTACTED, OPEN_NOT_CONTACTED],
          leadSources: [WEBSITE, WEB_TO_LEAD, PL_WEBSITE_PPC, PL_WEBSITE]
        },
        pagination: {
          page: 0,
          size: 1000
        }
      }) {
      count
    }
     voicePods: leadList(
      input: {
        filters: {
          isAssigned: true,
          leadStatuses: [NEW, OPEN_CONTACTED, OPEN_NOT_CONTACTED],
          product:[VOICEPOD,VOICEPOD_PRO]
        },
        pagination: {
          page: 0,
          size: 1000
        }
      }) {
      count
    }

    leads: leadList(input: { filters: {isAssigned: true,leadStatuses:[NEW,OPEN_CONTACTED,OPEN_NOT_CONTACTED] }, pagination: { page: 0, size: 1000 } }) {
      count
    }
    rejected: opportunityList(
      input: { filters: { status: [PRICING_REJECTED,PO_ACTIVATION_REJECTED,DEPLOYMENT_REJECTED] }, pagination: { page: 0, size: 1000 } }
    ) {
      count
    }
    revisits: leadList(input: { filters: {isAssigned: true,leadSources:[REVISIT_LEAD_UPLOAD],revisitStatuses:[${GetAllRevisitStatuses(
  REVISIT_STATUS.REVISIT_INCOMPLETE,
)}] }, pagination: { page: 0, size: 1000 } }) {
      count
    }
    followup: leadList(
      input: {      
        filters: { scheduledFollowUp: "${getCurrentDateTimeForApi()}", isAssigned: true,status:NEW  }
        pagination: { page: 0, size: 1000 }
      }
    ) {
      count
      leads {
        rating
        shop {
          address {
            addressLine1
            addressLine2
            addressLine3
            area
            district
            city
            state
            country
            pincode
            latitude
            longitude
          }
          name
        }
        id
        panNumber
        modifiedAt
        scheduledFollowUp
        status
        contact {
          name
          email
          number {
            number
          }
          role
        }
      }
    }
  }
`

export const GET_OPPRTUNITY_BY_ID = gql`
  query opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      id
      leadId
      accountId
      status
      primaryBillingEntityId
      primaryStoreId
      bankAccountId
      accountMccId
      crmRefId
      contactId
      isExistingMerchant
      soType
      annualturnoverpreviousfinancialyr
      documents {
        count
        documentList {
          id
          documentName
          documentRecordLink
          externalDocumentURL
          documentType
          documentMode
          documentSubType
          documentSource
          documentPages
          offlineAcceptance
          purchaseOrderId
          cseL1Remarks
          cseL1Status
          cseL2Remarks
          cseL2Status
          status
          uniqueIdentifier
          latLng {
            latitude
            longitude
          }
        }
      }
      purchaseOrder {
        poActivationStatus
      }
        enableServicenow
    }
  }
`

export const GET_OPPORTUNITY_FOR_BANK_ACCOUNT = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      id
      accountId
      bankAccountId
      annualturnoverpreviousfinancialyr
      documents {
        count
        documentList {
          id
          documentName
          documentType
          documentSubType
          documentPages
        }
      }
      purchaseOrder {
        poActivationStatus
      }
      enableServicenow
    }
  }
`

export const GET_OPPORTUNITY_FOR_PRODUCTS = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      id
      accountId
      regeneratePO
      crmRefId
      isProductEditableFromSA
      paymentType
      sponsorMerchantMappingId
      category
      primaryBillingEntityId
      accountMccId
      bankAccountId
      purchaseOrder {
        poRemarks
      }
      acquirer
      secondaryAcquirer
      requestType
      type
      soType
      onboardingMode
      enableServicenow
    }
  }
`

export const GET_OPPORTUNITY_WITH_DOCS_FOR_KYC = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      id
      leadId
      category
      accountId
      contactId
      aggregatorProductCount
      accountMccId
      documents {
        count
        documentList {
          id
          documentName
          documentPages
          documentSubType
          documentType
          uniqueIdentifier
          verifiedThroughOnlinePortal
        }
      }
      purchaseOrder {
        poAcceptanceEmail
      }
      kyc {
        url
        expiry
      }
      enableServicenow
    }
  }
`

export const GET_OPPRTUNITIES_BY_STATUS = gql`
  query opportunityList($input: GetOpportunitiesInput!) {
    opportunityList(input: $input) {
      count
      opportunities {
        id
        mdpOnboardingStatus
        name
        accountId
        nachSubmitted
        opportunitySubmitted
        leadId
        status
        category
        queryCode
        createdOn
        ownerType
        modifiedOn
        pricingApprovalComment
        cseRejectionData {
          cseRejectReason

          rejectionComments

          cseRejectSubReason
        }
        purchaseOrder {
          rectifyPoEligible
          rectifyPo
        }
        requestType
      }
    }
  }
`

export const GET_OPPRTUNITIES_BY_STATUS_WITHOUT_COUNT = gql`
  query opportunityList($input: GetOpportunitiesInput!) {
    opportunityList(input: $input) {
      opportunities {
        id
        name
        accountId
        nachSubmitted
        opportunitySubmitted
        leadId
        queryCode
        status
        category
        createdOn
        cseRejectionData {
          cseRejectReason

          rejectionComments

          cseRejectSubReason
        }
        purchaseOrder {
          rectifyPoEligible
          rectifyPo
        }
      }
    }
  }
`

export const GET_LEADS = gql`
  query leadList($input: GetLeadListInput!) {
    leadList(input: $input) {
      count
      leads {
        id
        status
        shop {
          name
        }
        contact {
          name
        }
        rating
        scheduledFollowUp
        leadSource
        createdAt
        ownerType
        revisitStatus
        posId
        ownerId
        deploymentFSREmployeeId
        deploymentFSRName
      }
    }
  }
`

export const GET_LEADS_BY_ID = gql`
  query lead($input: GetLeadInput!) {
    lead(input: $input) {
      id
      status
      modifiedAt
      panNumber
      shop {
        address {
          addressLine1
          addressLine2
          addressLine3
          area
          district
          city
          state
          country
          pincode
          latitude
          longitude
        }
        name
      }
      contact {
        name
        email
        number {
          number
        }
        role
      }
      rating
      notes
      scheduledFollowUp
      ownerType
      product
    }
  }
`

export const GET_PAN_DETAILS = gql`
  query GetPanDetails($input: PANDetailsInput!) {
    panDetails(input: $input) {
      name
      pan
      ownershipType
      valid
      dateOfBirth
    }
  }
`

export const GET_GST_DETAILS_FROM_PAN = gql`
  query Query($input: GSTfromPANDetailsInput!) {
    gstinsFromPAN(input: $input) {
      pan
      ownershipType
      gsts {
        businessName
        gstin
        dateOfIncorporation
        address {
          addressLine1
          addressLine2
          addressLine3
          pincode
          latitude
          longitude
          country
        }
      }
    }
  }
`

export const GET_GST_DETAILS = gql`
  query Query($input: GSTDetailsInput!) {
    gstDetails(input: $input) {
      pan
      ownershipType
      businessName
      dateOfIncorporation
      address {
        addressLine1
        addressLine2
        addressLine3
        pincode
        latitude
        longitude
        country
      }
    }
  }
`

export const GET_STATE_COUNT = gql`
  query merchantOnboardingStateV2($input: MerchantOnboardingStateInputV2!) {
    merchantOnboardingStateV2(input: $input) {
      stepsCount
      totalSteps
    }
  }
`

export const GET_LEAD_STATE = gql`
  query merchantOnboardingStateV2($input: MerchantOnboardingStateInputV2!) {
    merchantOnboardingStateV2(input: $input) {
      stateDataId
      idType
      configVersion
      steps {
        id
        name
        label
        type
        skippable
        hitAllNachApi
        isComplete
        editableConfig {
          editable
        }
        order
      }
      stepsCount
      totalSteps
    }
  }
`

export const AADHAAR_DETAILS_FROM_DIGILOCKER = gql`
  query aadhaarDetailsDigiLocker($input: GetAadhaarDetailsDigiLockerInput) {
    aadhaarDetailsDigiLocker(input: $input) {
      name
      address
      dateOfBirth
      gender
      photoUrl
      aadhaarUrl
      maskedNumber
      fatherSpouseName
      motherName
      salutation
    }
  }
`

export const MCC_QUERY = gql`
  query MccList {
    masterMccList {
      mccList {
        categoryType
        label
        subCategory {
          subCategoryType
          label
          merchantCategory {
            label
            mccCode
            riskCategory
          }
        }
      }
    }
  }
`

export const GET_SE_DETAILS = gql`
  query Query($input: ShopAndEstablishmentDetailsInput) {
    shopAndEstablishmentDetails(input: $input) {
      pan
      sneRegistrationNo
      businessName
      businessAddress
    }
  }
`

export const MCC_FROM_GSTN = gql`
  query MccsFromGSTIN($gstin: String!) {
    mccsFromGSTIN(gstin: $gstin) {
      gstin
      mccs {
        mccCode
      }
    }
  }
`

export const MERCHANT_DETAIL_BY_PAN = gql`
  query MerchantDetail($input: MerchantDetailsInput!) {
    merchantAccountDetails(input: $input) {
      id
      panNumber
      ownershipType
      accountType
      profile {
        name
        legalName
        isBlocked
        isExisting
        blockedOn
        allowedOn
      }
      lmsId
      dateOfIncorporation
      mobileNumber
      email
      revenue
      merchantMccDetail {
        id
        accountId
        businessCategoryType
        businessSubCategoryType
        merchantCategory
        mccCode
        isMCCManualEntry
      }
      merchantContactDetail {
        id
        accountId
        isPrimary
        email
        leadName
        mobileNumber
        designation
        addressDetails {
          addressLine1
          addressLine2
          landmark
          city
          state
          pinCode
          country
        }
      }
      addressDetails {
        addressLine1
        addressLine2
        landmark
        city
        state
        pinCode
        country
      }
    }
  }
`

export const MERCHANT_CONTACT_DETAIL_QUERY = gql`
  query MerchantMccAndContactData($input: MerchantMCCAndContactDataInput!) {
    merchantMccAndContactData(input: $input) {
      id
      merchantContactDetail {
        id
        accountId
        salutation
        fatherSpouseName
        motherName
        gender
        isPrimary
        email
        leadName
        mobileNumber
        designation
        dateOfBirth
        addressDetails {
          addressLine1
          addressLine2
          landmark
          city
          state
          pinCode
          country
        }
      }
    }
  }
`

export const MERCHANT_ACCOUNT_FOR_BANK = gql`
  query merchantAccountDetails($input: MerchantDetailsInput!) {
    merchantAccountDetails(input: $input) {
      id
      panNumber
      revenue
    }
  }
`

export const GET_MCC_FROM_GSTIN = gql`
  query ExtractMccs($input: ExtractMccsInput!) {
    extractMccs(input: $input) {
      mccs {
        mccCode
        mccDescription
      }
    }
  }
`

export const GET_LEADS_DETAILS_ON_PAN_SCREEN = gql`
  query lead($input: GetLeadInput!) {
    lead(input: $input) {
      id
      panNumber
      gstin
      ownerType
      contact {
        email
      }
    }
  }
`

export const GET_COUNTRY_STATE_LIST = gql`
  query MasterStateList {
    masterStateList {
      code
      name
    }
  }
`

export const MERCHANT_DETAIL_BY_ACC = gql`
  query MerchantDetail($input: MerchantDetailsInput!) {
    merchantAccountDetails(input: $input) {
      id
      panNumber
      ownershipType
      accountType
      merchantContactDetail {
        id
        leadName
        mobileNumber
        email
      }
      merchantMccDetail {
        mccCode
        merchantCategory
      }
      addressDetails {
        state
        pinCode
        addressLine1
        addressLine2
        landmark
        country
        city
      }
      profile {
        legalName
      }
      isRelatedToPep
      isPoliticallyExposed
      pepJudiciary
    }
  }
`

export const GET_CITY_BY_STATE = gql`
  query CityList($input: CityListInput!) {
    cityList(input: $input) {
      id
      name
      stateCode
    }
  }
`

export const GET_PO_STATUS = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      status
      purchaseOrder {
        onlineAcceptanceStatus
      }
    }
  }
`

export const GET_OPPORTUNITY_WITH_DOCUMENT = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      status
      leadId
      regeneratePO
      accountId
      minNachAmount
      primaryBillingEntityId
      contactId
      deploymentStatus
      category
      sponsorMerchantMappingId
      aggregatorProductCount
      acquirer
      nachSubmitted
      opportunitySubmitted
      paymentType
      bankAccountId
      totalAmount
      accountMccId
      purchaseOrder {
        poLink

        poActivationStatus
        offlinePOGeneration
        sendOnlineAcceptance
        poAcceptanceEmail
        poAcceptanceMobile
        applicationStatus
        onlineAcceptanceStatus
      }
      documents {
        count
        documentList {
          id
          documentName
          documentRecordLink
          externalDocumentURL
          documentType
          documentSubType
          documentMode
          documentSource
          documentPages
          offlineAcceptance
          purchaseOrderId
          cseL1Remarks
          cseL1Status
          cseL2Remarks
          cseL2Status
          status
          uniqueIdentifier
          latLng {
            latitude
            longitude
          }
        }
      }
      totalAmount
      payments {
        paymentList {
          id
          paymentMode
          bankName
          collectionDate
          depositDate
          amount
          status
          invoiceTxnRefNo
          initiationTime
        }
      }
      kyc {
        url
        expiry
      }
      requestType
    }
  }
`

export const GET_OPPORTUNITY_PAYMENT = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      accountId
      totalAmount
    }
  }
`

export const GET_BILLING_DETAIL_BY_ID = gql`
  query BillingEntity($input: BillingEntityInput!) {
    billingEntity(input: $input) {
      id
      merchantId
      kycDocumentType
      kycDocumentNo
      mode
      nameToBePrintedOnPO
      businessAddress {
        addressLine1
        addressLine2
        landmark
        city
        state
        pinCode
        country
      }
    }
  }
`

export const GET_DEPLOY_STORE = gql`
  query DeploymentStore($input: DeploymentStoreInput!) {
    deploymentStore(input: $input) {
      id
      merchantId
      name
      primaryContactId
      pcId
      address {
        addressLine1
        addressLine2
        addressLine3
        cityId
        stateCode
        country
        pincode
        latitude
        longitude
      }
    }
  }
`

export const GET_OPP_WITH_PRODUCTS = gql`
  query opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      accountId
      status
      leadId
      contactId
      bankAccountId
      paymentType
      category
      primaryBillingEntityId
      crmRefId
      deploymentStatus
      nachSubmitted
      opportunitySubmitted
      primaryStoreId
      totalAmount
      oldDeploymentFlow
      requestType
      onboardingMode
      type
      posList
      lmsID
      approvalStatus
      stageName
      poNumber
      status
      acquirer
      cseL1CaseStatus
      purchaseOrder {
        poLink
        poActivationStatus
        offlinePOGeneration
        sendOnlineAcceptance
        poAcceptanceEmail
        poAcceptanceMobile
        applicationStatus
        onlineAcceptanceStatus
        rectifyPoEligible
      }
      documents {
        documentList {
          documentType
        }
      }
      products {
        productList {
          id
          name
          productName
          productType
          quantity
          description
          opportunityId
        }
      }
    }
  }
`

export const OPPORTUNITY_FOR_REVIEW = gql`
  query opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      accountId
      contactId
      bankAccountId
      totalAmount
      requestType
      purchaseOrder {
        poAcceptanceEmail
        poAcceptanceMobile
      }
      documents {
        documentList {
          id
          documentType
          documentSubType
        }
      }
      products {
        productList {
          id
          name
          productName
          productType
          quantity
        }
      }
      primaryBillingEntityId
    }
  }
`

export const MERCHANT_AND_BANK = gql`
  query MerchantAccountAndBankAccount(
    $bankAccountInput: GetBankAccountInput!
    $merchantAccountInput: MerchantDetailsInput!
    $billingInput: BillingEntityInput!
    $contactInput: MerchantMCCAndContactDataInput!
  ) {
    bankAccount(input: $bankAccountInput) {
      accountHolderName
      bankAccountNumber
      id
      ifscCode
      bankName
    }
    merchantAccountDetails(input: $merchantAccountInput) {
      id
      ownershipType
      revenue
      panNumber
      profile {
        name
      }
      merchantMccDetail {
        id
        businessCategoryType
        businessSubCategoryType
        merchantCategory
      }
      addressDetails {
        addressLine1
        addressLine2
        city
        state
        pinCode
      }
    }
    billingEntity(input: $billingInput) {
      gstin
    }
    merchantMccAndContactData(input: $contactInput) {
      merchantContactDetail {
        email
        mobileNumber
        firstName
        lastName
      }
    }
  }
`

export const QUERY_KYC_STATUS = gql`
  query KYCVerificationRequestStatus($input: KYCVerificationRequestStatusInput!) {
    kycVerificationRequestStatus(input: $input) {
      status
      attributeVerificationResults {
        attributeType
        status
        score
        thresholdScore
      }
    }
  }
`

export const ONLY_KYC_STATUS = gql`
  query KYCVerificationRequestStatus($input: KYCVerificationRequestStatusInput!) {
    kycVerificationRequestStatus(input: $input) {
      status
    }
  }
`

export const QUERY_MANDATE_STATUS = gql`
  query EMandate($input: GetEMandateInput!) {
    eMandate(input: $input) {
      nachServiceId
      mandateStatus
      redirectUrl
      requestId
      sourceId
      mandateType
      mandateStatusCode
      mandateStatusDescription
      reference1
      mandateMode
    }
  }
`

export const QUERY_E_SIGN_MANDATE = gql`
  query ESignMandate($input: GetESignMandateInput!) {
    eSignMandate(input: $input) {
      nachServiceId
      mandateStatus
      redirectUrl
      requestId
      sourceId
      mandateType
      reference1
      mandateStatusCode
      mandateStatusDescription
      mandateMode
    }
  }
`

export const GET_DL_DETAILS = gql`
  query DLDetail($input: DLDetailsSearchInput!) {
    dlDetails(input: $input) {
      name
      dob
      completeAddress
    }
  }
`

export const GET_ALL_DEPLOYMENTS = gql`
  query posDeployment($input: PosDeploymentInput!) {
    posDeployment(input: $input) {
      opportunityId
      bankName
      acquirerId
      deployments {
        posDetails {
          id
          name
          type
          vas {
            id
            name
            isEditable
            productId
            terminals {
              id
              name
              tid
              mid
              revNumber
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_DEPLOYMENTS_NEW = gql`
  query posDeployment($input: GetPosDeploymentInput!) {
    posDeployment(input: $input) {
      opportunityId
      acquirerId
      bankName
      deployments {
        posDetails {
          id
          name
          assetType
          status
          statusCategory
          isEditable
          posId
          deploymentStatus
          crmTicketId
          selfDeployment
          vas {
            id
            name
            productId
            isEditable
            crmRefId
            terminals {
              id
              tid
              mid
              revNumber
              name
              isEditable
            }
          }
        }
        paymentDevices {
          id
          deploymentStatus
          name
          type
          status
          statusCategory
          isEditable
          posId
          selectedPos
        }
      }
    }
  }
`

export const GET_ACCESSORY_DEPLOYMENTS = gql`
  query accessoryDeployments($input: GetPosDeploymentInput!) {
    accessoryDeployments(input: $input) {
      opportunityId
      acquirerId
      accessories {
        id
        name
        status
        statusCategory
        isEditable
        parentPosAssetId
        parentPosId
        parentPosName
        parentPosStatus
        storeId
        deploymentDetailId
      }
    }
  }
`

export const GET_DL_DATA_BY_PAN_NUMBER = gql`
  query Query($input: KYCDocEExtractionInput!) {
    kycDocEExtractedData(input: $input) {
      kycRefId
      detailedData {
        documentNumber
        name
        dob
        guardianName
        completeAddress
        photoUrl
        address {
          addressLine1
          addressLine2
          addressLine3
          area
          district
          city
          state
          country
          pincode
          latitude
          longitude
        }
      }
    }
  }
`

export const QUERY_BANK_ACCOUNT_DETAILS = gql`
  query bankAccount($input: GetBankAccountInput!) {
    bankAccount(input: $input) {
      id
      accountId
      bankName
      bankAccountNumber
      accountType
      ifscCode
      accountHolderName
      signzyBeneficiaryName
    }
  }
`

export const BANK_ACCOUNTS = gql`
  query GetFilteredBankAccount($input: GetFilteredBankAccountInput) {
    getFilteredBankAccount(input: $input) {
      bankAccounts {
        id
        accountId
        bankAccountNumber
        accountType
        ifscCode
        accountHolderName
        pennyDropSuccess
        nameMatchSuccess
        failureReason
        signzyBeneficiaryName
        bankName
        isEditable
        cancelledCheque
      }
    }
  }
`

export const QUERY_TRANSACTION_STATUS = gql`
  query getOpportunityPaymentStatus($input: OpportunityPaymentStatusInput!) {
    getOpportunityPaymentStatus(input: $input) {
      status
      paymentLink
      paymentId
      vpa
      intentURIData
    }
  }
`

export const GET_PRODUCT_DETAIL = gql`
  query opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      accountId
      accountMccId
      acquirer
      requestType
      settlement {
        cycle
      }
      category
      allVASCheck
      secondaryAcquirer
      onboardingMode
    }
  }
`

export const GET_CITY_DETAIL_BY_NAME = gql`
  query CityDetails($input: CityDetailsInput!) {
    cityDetails(input: $input) {
      id
      name
      stateCode
      stateName
    }
  }
`

export const GET_CITY_STATE_NAME_BY_ID = gql`
  query StateAndCityNameFromCityId($input: StateCityNameFromCityIdInput!) {
    stateAndCityNameFromCityId(input: $input) {
      stateName
      cityName
    }
  }
`

export const GET_ADDREESS_BY_LATLNG = gql`
  query LocateMeAddress($input: LocateMeAddressInput!) {
    locateMeAddress(input: $input) {
      addressLine1
      addressLine2
      addressLine3
      area
      district
      city
      state
      country
      pincode
    }
  }
`

export const GET_PRODUCTS_PRICING = gql`
  query opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      crmRefId
      paymentType
      products {
        productList {
          id
          name
          productName
          productType
          quantity
          description
        }
      }
      purchaseOrder {
        poRemarks
      }
    }
  }
`

export const GET_CITY_STATE_FROM_CODE = gql`
  query StateAndCityName($input: StateCityNameInput!) {
    stateAndCityName(input: $input) {
      stateName
      cityName
      stateCode
      cityId
    }
  }
`

export const GET_SALESAPP_VERSION = gql`
  query SalesAppLatestVersion {
    salesAppLatestVersion {
      updateType
      version
    }
  }
`

export const GET_PMANDATE_STATUS = gql`
  query PMandate($input: GetPMandateInput!) {
    pMandate(input: $input) {
      nachServiceId
      mandateStatus
      redirectUrl
      requestId
      sourceId
      mandateType
      reference1
      mandateStatusCode
      mandateStatusDescription
      isSignUploaded
      mandateMode
    }
  }
`

export const GET_MULTISTORE_LISTS = gql`
  query DeploymentStoresByMerchantId($input: DeploymentStoreDetailsInput!) {
    deploymentStoresByMerchantId(input: $input) {
      stores {
        id
        merchantId
        primaryContactId
        name
        documentType
        documentNumber
        storeCode
        pcId
        address {
          addressLine1
          addressLine2
          addressLine3
          cityId
          stateCode
          country
          pincode
          latitude
          longitude
        }
      }
    }
  }
`

export const GET_ALL_SIGNATORY_INFO = gql`
  query GetMerchantSignatoryDetails($input: MerchantSignatoryDetailsInput!) {
    merchantSignatoryInfo(input: $input) {
      merchantSignatoryDetails {
        id
        accountId
        panNumber
        panName
        individualKycType
        stakePercentage
        kycCompleted
        isPoliticallyExposed
        isRelatedToPep
        judiciary
        isPrimaryContact
        dateOfBirth
        isKycSubmitted
        poaNumber
        poaAddress
        fatherSpouseName
        motherName
        salutation
        gender
      }
    }
  }
`
export const GET_LLPIN_DETAILS = gql`
  query LlpinDetails($input: LLPINDetailsInput!) {
    llpinDetails(input: $input) {
      pan
      ownershipType
      businessName
      address {
        addressLine1
        addressLine2
        addressLine3
        area
        district
        city
        state
        country
        pincode
        latitude
        longitude
      }
      dateOfIncorporation
    }
  }
`

export const GET_CIN_DETAILS = gql`
  query CinDetails($input: CINDetailsInput!) {
    cinDetails(input: $input) {
      pan
      ownershipType
      businessName
      address {
        addressLine1
        addressLine2
        addressLine3
        area
        district
        city
        state
        country
        pincode
        latitude
        longitude
      }
      dateOfIncorporation
    }
  }
`

export const GET_CIN_FROM_PAN = gql`
  query CinsFromPAN($input: CINsFromPanInput!) {
    cinsFromPAN(input: $input) {
      pan
      ownershipType
      cins {
        businessName
        cin
      }
    }
  }
`

export const SEARCH_MERCHANT_BY_NAME_PAN = gql`
  query MerchantFilter($input: MerchantFilterInput!) {
    merchantFilter(input: $input) {
      accountId
      panNumber
      name
      accountType
      ownershipType
    }
  }
`
export const SEARCH_CONTACT_LIST_BY_ACCOUNT_ID = gql`
  query ContactList($input: ContactListInput!) {
    contactList(input: $input) {
      accountId
      id
      email
      mobileNumber
      dateOfBirth
      designation
      isPrimary
      addressDetails {
        addressLine1
        addressLine2
        city
        country
        landmark
        pinCode
        state
      }
    }
  }
`
export const MERCHANT_CONTACT_MCC = gql`
  query MerchantDetail($input: MerchantDetailsInput!) {
    merchantAccountDetails(input: $input) {
      id
      panNumber
      ownershipType
      merchantMccDetail {
        id
        accountId
        businessCategoryType
        businessSubCategoryType
        merchantCategory
        mccCode
        isMCCManualEntry
      }
      merchantContactDetail {
        leadName
        dateOfBirth
      }
      profile {
        name
        legalName
      }
      addressDetails {
        addressLine1
        addressLine2
        landmark
        city
        state
        pinCode
        country
      }
    }
  }
`
export const GET_BILLING_ENTITIES = gql`
  query BillingEntities($input: FilterBillingEntitiesInput!) {
    getFilteredBillingEntities(input: $input) {
      count
      billingEntities {
        id
        businessName
        mode
        nameToBePrintedOnPO
        businessAddress {
          addressLine1
          addressLine2
          landmark
          city
          state
          pinCode
          country
        }
        kycDocumentType
        kycDocumentNo
        isEditable
      }
    }
  }
`

export const GET_EDITABLE_STATUS = gql`
  query EditableIds($input: GetEditableIdsInput!) {
    editableIds(input: $input) {
      entityName
      editableIds {
        id
        isEditable
      }
    }
  }
`

export const GET_KYC_STATUS_FROM_RULE_ENGINE = gql`
  query KycStatusData($input: KYCStatusInput!) {
    kycStatusData(input: $input) {
      uploadedDocuments {
        type
        url
      }
    }
  }
`

export const GET_UDYAM_DETAILS = gql`
  query UdyamQuery($input: UdyamRegnSearchInput!) {
    udyamRegnSearch(input: $input) {
      requestId
      udyamList {
        udyamNumber
        businessName
        dateOfIncorporation
        address {
          addressLine1
          addressLine2
          addressLine3
          country
          pincode
          latitude
          longitude
        }
        documentUrl
        documentUtilUrl
      }
    }
  }
`

export const CHECK_EXPERIMENT_ALLOWED = gql`
  query CheckEmailInExperiment($input: CheckEmailInExperimentInput!) {
    checkEmailInExperiment(input: $input) {
      isValid
    }
  }
`

export const GET_BANK_ACCOUNT_ID_BY_OPPORTUNITY_ID = gql`
  query GetBankAccoutByOpportunityId($input: GetBankAccountIdInput!) {
    getBankAccoutByOpportunityId(input: $input) {
      bankAccount
    }
  }
`
export const GET_PRODUCT_LIST = gql`
  query ProductList($input: ProductListInput!) {
    productList(input: $input) {
      totalSize
      products {
        productId: id
        productName: name
        type
        imageUrl
        hardwareSubTypeName
      }
    }
  }
`
export const GET_DEPLOYMENT_ASSETS = gql`
  query deploymentRequestByAssetId($input: GetDeploymentAssetInput!) {
    deploymentRequestByAssetId(input: $input) {
      id
      assetName
      acquirer
      storeName
      address {
        addressLine1
        addressLine2
        addressLine3
        area
        district
        city
        state
        country
        pincode
        latitude
        longitude
      }
      mobile
      crmTicketId
      email
      createdDate
      posId
      workFlowState
      status
      upiTxnProof
      cardTxnProof
      isProductsConsumed
      isLinkingDone
      cardTestTransactionApplicable
      upiTestTransactionApplicable
      linkingApplicable
      acknowledgement
      acknowledgmentBypassReason
      storeId
      bankName
      meTeamStatus
      inventoryUserNameEmpCode
      productsConsumedList {
        productName
        productType
        productSerialNumber
        isChildAsset
      }
      mappedDevicesList {
        linkedAssetName
      }
    }
  }
`

export const QUERY_ACTIVE_POS = gql`
  query GetPOS($input: GetPOSInput!) {
    getPOS(input: $input) {
      posDetails {
        id
        name
        type
        assetType
        isEditable
        status
        statusCategory
        posId
        storeId
        opportunityId
        deploymentStatus
        selfDeployment
        crmTicketId
        installDate
        hardwareLiveDate
        deploymentDate
        vas {
          id
          name
          productId
          isEditable
          deploymentDate
          liveDate
          acquirerId
          configurationDate
          billingStartDate
          billingEndDate
          deinstallationDate
          txnStartDate
          txnStopDate
          replacementDate
        }
      }
    }
  }
`

export const GET_PLAN_LIST = gql`
  query PlanList($input: PlanListInput!) {
    planList(input: $input) {
      plans {
        planId: id
        planName: name
        isPrimeEnabled
        standardProductWrapper {
          advanceMonth
          vas
          bom
          fees {
            label
            value
          }
          mdrDetails {
            cardType
            acquirerBank
            cardType
            fixedValue
            mdrId
            productID
            feeTypeLabel
            productName
            rateType
            slabValMDR
            slabValueDetails {
              cardNetwork
              mdrType
              slabList {
                annualTurnover {
                  capAmount
                  lowerLimitAmount
                  rate
                  rateType
                  upperLimitAmount
                }
                lowerLimit
                rate
                rateType
                upperLimit
              }
            }
            vasName
          }
        }
        relatedProductsWrapper {
          advanceMonth
          vas
          bom
          fees {
            label
            value
          }
          mdrDetails {
            cardType
            acquirerBank
            cardType
            feeTypeLabel
            fixedValue
            mdrId
            productID
            productName
            rateType
            slabValMDR
            slabValueDetails {
              cardNetwork
              mdrType
              slabList {
                annualTurnover {
                  capAmount
                  lowerLimitAmount
                  rate
                  rateType
                  upperLimitAmount
                }
                lowerLimit
                rate
                rateType
                upperLimit
              }
            }
            vasName
          }
        }
      }
    }
  }
`

export const GET_PRODUCT_SELECTIONS = gql`
  query GetOpportunityProduct($input: GetOpportunityProductInput!) {
    getOpportunityProduct(input: $input) {
      products {
        productId
        productName
        plans {
          planId
          planName
          quantity
          relatedPlanBundleId
        }
      }
    }
  }
`
export const GET_INVENTORY = gql`
  query Query($input: ProductsRequiredAndInventoryInput!) {
    productsRequiredAndInventory(input: $input) {
      productsRequiredAndInventoryDetails {
        productName
        productType
        mandatory
        childAsset
        parentAsset
        inventoryDetailsList {
          id
          srno
          pqrId
          pqrSrno
          productItemNumber
        }
      }
    }
  }
`

export const DEVICE_TO_LINK = gql`
  query devicesToBeLinked($input: GetDevicesToBeLinkedInput!) {
    devicesToBeLinked(input: $input) {
      paymentDevice {
        deviceId
        deviceCrmRefId
        deviceName
        deviceType
      }
      devicesToBeLinked {
        id
        posId
        crmRefId
        name
        assetType
        alreadyLinked
        deviceMappingResponse
        isLive
        inProgress
      }
    }
  }
`

export const VALIDATE_VPA = gql`
  query ValidateVPA($input: validateVPAInput!) {
    validateVPA(input: $input) {
      isVPAValid
      isVPAEligible
      payerAccountName
    }
  }
`
export const GET_ACHLIST = gql`
  query AchList($input: GetACHInput!) {
    achList(input: $input) {
      ach {
        mandateStatus
        mandateType
        mandateStartDate
        mandateEndDate
        mandateAmount {
          value
          currency
        }
        redirectUrl
        isActive
        requestId
        reference1
        intentURIData
      }
    }
  }
`

export const EXTRACTED_DATA = gql`
  query ExtractedData($input: GetExtractedDataInput!) {
    getExtractedData(input: $input) {
      extractedData {
        eExtractedData {
          documentNumber
          extractedData {
            name
            dob
            ownershipType
          }
        }
        documentType
      }
    }
  }
`

export const GENERATE_KYC_LINK = gql`
  query KycLink($input: GetKYCLinkInput!) {
    kycLink(input: $input) {
      url
      expiry
    }
  }
`
export const GET_INVENTORY_COUNT = gql`
  query Query($input: ProductsRequiredAndInventoryInput!) {
    productsRequiredAndInventory(input: $input) {
      productsRequiredAndInventoryDetails {
        productName
      }
    }
  }
`

export const MERCHANT_AND_BANK_BILLING = gql`
  query MerchantAccountAndBankAccount(
    $bankAccountInput: GetBankAccountInput!
    $billingInput: BillingEntityInput!
    $accountInput: MerchantDetailsInput!
  ) {
    merchantAccountDetails(input: $accountInput) {
      id
      panNumber
      ownershipType
      accountType
      merchantContactDetail {
        id
        leadName
        mobileNumber
      }
      merchantMccDetail {
        mccCode
        id
      }
      addressDetails {
        state
        pinCode
        addressLine1
        addressLine2
        landmark
        country
        city
      }
    }
    bankAccount(input: $bankAccountInput) {
      id
      accountId
      bankAccountNumber
      accountType
      ifscCode
      accountHolderName
      signzyBeneficiaryName
    }
    billingEntity(input: $billingInput) {
      id
      merchantId
      kycDocumentType
      kycDocumentNo
      nameToBePrintedOnPO
      businessAddress {
        addressLine1
        addressLine2
        landmark
        city
        state
        pinCode
        country
      }
    }
  }
`
export const GET_PRODUCT_COUNT = gql`
  query GetOpportunityProduct($input: GetOpportunityProductInput!) {
    getOpportunityProduct(input: $input) {
      products {
        productId
      }
    }
  }
`

export const GET_ALL_PRODUCT_ITEMS = gql`
  query GetProductItems($input: GetProductItemsInput!) {
    getProductItems(input: $input) {
      productItemsList {
        id
        productItemNumber
        productType
        productName
        quantityOnHand
        serialNumber
        productSecondarySerialNumber
        productWorkingConditionStatus
        inTransit
        receivingDate
      }
    }
  }
`
export const GET_PRODUCT_TRANSFERS = gql`
  query GetProductTransfers($input: GetProductTransfersInput!) {
    getProductTransfers(input: $input) {
      productTransfersList {
        id
        serialNumber
        productItemId
        quantityOnHand
        productName
        productType
        createdDate
        destinationLocationId
        destinationLocationName
        destinationLocationEmployeeId
        status
      }
    }
  }
`

export const GET_PRODUCT_TRANSFERS_FOR_ASSIGNED = gql`
  query GetProductTransfers($input: GetProductTransfersInput!) {
    getProductTransfers(input: $input) {
      productTransfersList {
        id
        serialNumber
        productItemId
        quantityOnHand
        productName
        productType
        createdDate
        courierName
        trackingNumber
      }
    }
  }
`
export const GET_PRODUCTS_CONSUMEND = gql`
  query GetProductsConsumed($input: GetProductsConsumedInput!) {
    getProductsConsumed(input: $input) {
      productsConsumedList {
        id
        productName
        productType
        serialNumber
        productItemId
        quantityConsumed
        createdOn
        modifiedOn
        storeDetails {
          name
          address1
          address2
        }
        productItemNumber
      }
    }
  }
`
export const GET_LOCATION_FILTER = gql`
  query Query($input: LocationFilterInput!) {
    LocationFilter(input: $input) {
      id
      name
      employeeId
    }
  }
`
export const GET_PRODUCT_TRANSFER_USING_PRODUCT_ID = gql`
  query GetProductTransfer($input: GetProductTransferInput!) {
    getProductTransfer(input: $input) {
      id
      destinationLocationName
      destinationLocationEmployeeId
      destinationLocationId
    }
  }
`

export const MERCHANT_AND_BANK_STORE = gql`
  query MerchantAccountAndBankAccount(
    $bankAccountInput: GetBankAccountInput!
    $merchantAccountInput: MerchantDetailsInput!
    $deploymentInput: DeploymentStoreInput!
    $contactDetails: MerchantMCCAndContactDataInput!
  ) {
    bankAccount(input: $bankAccountInput) {
      accountHolderName
      bankAccountNumber
      id
      bankName
      accountType
      ifscCode
    }
    merchantAccountDetails(input: $merchantAccountInput) {
      id
      merchantMccDetail {
        id
        mccCode
        merchantCategory
      }
    }
    deploymentStore(input: $deploymentInput) {
      id
      merchantId
      name
      primaryContactId
      address {
        addressLine1
        addressLine2
        addressLine3
        cityId
        stateCode
        country
        pincode
        latitude
        longitude
      }
    }
    merchantMccAndContactData(input: $contactDetails) {
      id
      merchantContactDetail {
        id
        email
        leadName
        mobileNumber
      }
    }
  }
`
export const GET_SPONSORED_DETAILS = gql`
  query GetSponsorMerchantMapping($input: SponsorMerchantMappingInput!) {
    getSponsorMerchantMapping(input: $input) {
      sponsorMerchantMappingDetails {
        id
        panNumber
        availableDevices
        sponsorName
        cumulativeSponsoredDevices
      }
    }
  }
`
export const GET_ALL_PLANS = gql`
  query Query($input: getAllPlans) {
    getAllPlans(input: $input) {
      plans {
        id
        sfReferenceId
        name
        description
        advanceMonth
        createdOn
        modifiedOn
        active
        aggregator
      }
    }
  }
`

export const GET_MDR_DETAILS = gql`
  query GetMDRFee($input: GetMDRFee) {
    getMDRFee(input: $input) {
      id
      sfReferenceId
      name
      cardSegment
      cardSegmentId
      instrumentType
      slabList
      value
      issuer
      insurancePartner
      insuranceSubPartner
      vasReference
      insuranceIssuer
      insuranceProvider
      createdOn
      modifiedOn
      createdBy
      modifiedBy
      active
    }
  }
`
export const GET_PRODUCT_BY_PLAN_ID = gql`
  query GetProductsViewByPlan($input: GetProductsViewByPlanInput) {
    getProductsViewByPlan(input: $input) {
      id
      sfReferenceId
      name
      description
      salesCategory
      mccList
      advanceMonth
      advanceMonthEditable
      customAdvancedMonth
      pricingType
      nbsId
      vasReferenceId
      customAdvancedMonth
      pricingType
      planId
      productType
      recommended
      fees {
        id
        feemappingreferenceid
        sfReferenceId
        name
        fee
        customValue
        pricingType
        feeType
        unitOfMeasurement
        value
        minValue
        maxValue
        frequency
        downStreamNBSId
        entityType
        navFeeCode
        subscription
        createdOn
        active
        customValue
        pricingType
        feemappingreferenceid
        editable
      }
      posProduct {
        id
        sfReferenceId
        name
        feeMappingReference
        productImageUrl
        posType
        hardwareModel
        downstreamPosId
        edcType
        edcItemNumber
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        active
      }
      feeMappingReference
      vasProduct {
        id
        sfReferenceId
        aggregatorCategory
        downstreamVasId
        name
        aggregatorProgramId
        aggregatorProgramName
        feeMappingReference
        bankDetails
        settlementCycle
        modeOfPay
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        active
        pg
        accessory
        mdrfees {
          id
          sfReferenceId
          name
          cardSegment
          cardSegmentId
          instrumentType
          slabList
          value
          issuer
          insurancePartner
          insuranceSubPartner
          vasReference
          insuranceIssuer
          insuranceProvider
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          active
          mdrType
          pricingType
          enabled
          merchantSplit
          insurerSplit
          pinelabsSplit
          editable
        }
      }
      eligibleFor3PUser
      category
      businessSubCategory
      quantity
      sortOrder
      createdOn
      modifiedOn
      createdBy
      modifiedBy
      active
      aggregator
      acquirer
      mandatory
    }
  }
`

export const GET_OPPORTUNITY_ENTITY_IDS = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      id
      accountId
      bankAccountId
      accountMccId
      contactId
    }
  }
`

export const GET_VAS = gql`
  query GetVAS($input: GetVASInput!) {
    getVAS(input: $input) {
      vasDetails {
        id
        name
        productId
        isEditable
        deploymentDate
        liveDate
        acquirerId
        status
        acquirerBankName
        opportunityLineItemId
      }
    }
  }
`

export const GET_ALL_INSURANCE_PARTNERS = gql`
  query GetAllInsurancePartners {
    getAllInsurancePartners {
      insuranceExternalPartnerId
      insurancePartnerName
      warrantyTypes {
        warrantyTypeExternalId
        warrantyType
      }
    }
  }
`

export const GET_VAS_TID = gql`
  query GetVasTid($input: GetVASInput!, $tidInput: GetTIDInput!) {
    getVAS(input: $input) {
      vasDetails {
        id
        name
        status
        productId
        isEditable
        acquirerBankName
        deploymentDate
        liveDate
        acquirerId
      }
    }
    getTID(input: $tidInput) {
      terminalDetails {
        id
        name
        vasAssetId
        tid
        mid
        revNumber
        isEditable
        liveDate
      }
    }
  }
`

// export const GET_VAS = gql`
//   query GetVasTid($input: GetVASInput!, $tidInput: GetTIDInput!) {
//     getVAS(input: $input) {
//       vasDetails {
//         id
//         name
//         status
//         productId
//         isEditable
//         acquirerBankName
//         deploymentDate
//         liveDate
//         acquirerId
//       }
//     }
//   }
// `
export const GET_ALL_OLIS = gql`
  query Query($input: GetAllOLIInput) {
    getAllOLIs(input: $input) {
      id
      planId
      name
      productId
      accountId
      opportunityId
      priceType
      customAdvanceMonth
      standardAdvanceMonth
      standardPrice
      customPrice
      customPriceToDisplay
      quantity
      buyPrice
      unitPrice
      listPrice
      subTotal
      total
      acquirer
      bankAccountDetail
      cseL1Status
      cseL2Status
      riskStatus
      gstRate
      mcc
      unitOfMeasurement
      setupFee
      subscriptionFee
      nbsId
      type
      vasReferenceId
      posReferenceId
      feeReferenceId
      mdrFeeReferenceId
      edcItemNumber
      createdOn
      modifiedOn
      createdBy
      modifiedBy
      feeMappingReferenceId
      aggregator
      downstreamVasId
    }
  }
`

export const GET_ALL_POS_PRODUCT = gql`
  query AllPosProduct($input: getAllPosProduct) {
    allPosProduct(input: $input) {
      posProducts {
        id
        sfReferenceId
        name
        feeMappingReference
        posType
        hardwareModel
        downstreamPosId
        edcType
        edcItemNumber
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        productImageUrl
        subTypeVersionId
        subTypeVersionName
        hardwareSubTypeId
        hardwareSubTypeName
        active
      }
    }
  }
`
export const GET_MDR_DETAILS_V2 = gql`
  query GetMDRFee($input: GetMDRFee) {
    getMDRFee(input: $input) {
      id
      sfReferenceId
      name
      cardSegment
      cardSegmentId
      instrumentType
      editable
      slabList
      value
      issuer
      insurancePartner
      insuranceSubPartner
      vasReference
      insuranceIssuer
      insuranceProvider
      createdOn
      modifiedOn
      createdBy
      modifiedBy
      active
      acquirer
      mdrType
    }
  }
`
export const GET_VISIT_LEAD = gql`
  query lead($input: GetLeadInput!) {
    lead(input: $input) {
      signUpDate
      onboardingDate
      mtdTxn
      mtdTxnDays
      lastMonthTxn
      lastMonthTxnDays
      lastThirtyDaysGTV
      lastDeviceNotificationDate
      lastTxnDate
      countOfDevicesMapped
      posId
      customerId
      deploymentFSREmployeeId
      deploymentFSRName
      isStarMerchant
      servicesActive
      acquirer
      byPassLeadClosureOtp
      deploymentFSRName
      deploymentFSREmployeeId
    }
  }
`
export const GET_REVISIT_LEAD_STATUS = gql`
  query GetLeadStatus($input: GetLeadInput!) {
    getLeadStatus(input: $input) {
      id
      leadSource
      status
      revisitStatus
      reasonsForNotAcceptingPayments
      resolutionsProvidedAtRevisit
    }
  }
`
export const GET_REVISIT_LEAD_WITH_STATUS = gql`
  query leadData($input: GetLeadInput!) {
    getLeadStatus(input: $input) {
      id
      leadSource
      status
      revisitStatus
    }
    lead(input: $input) {
      id
      status
      modifiedAt
      shop {
        address {
          addressLine1
          addressLine2
          addressLine3
          area
          district
          city
          state
          country
          pincode
          latitude
          longitude
        }
        name
      }
      contact {
        name
        email
        number {
          number
        }
        role
      }
      scheduledFollowUp
      reasonsForNotAcceptingPayments
      resolutionsProvidedAtRevisit
      byPassLeadClosureOtp
      deploymentFSRName
      deploymentFSREmployeeId
    }
  }
`
export const GET_ELIGIBLE_APP_VERSION = gql`
  query Query($input: GetEligibleAppVersionInput!) {
    getEligibleAppVersion(input: $input) {
      appVersion {
        version
      }
    }
  }
`
export const VERIFY_LOCATION = gql`
  query verifyLocationDetail($input: VerifyLocationInput!) {
    verifyLocation(input: $input) {
      withinRadius
      distanceMeters
      thresholdMeters
      referenceLat
      referenceLng
      reportedLat
      reportedLng
      posId
      storeId
    }
  }
`
export const POST_LIST_BY_LEAD = gql`
  query Query($input: posListByLeadIdInput!) {
    posListByLeadId(input: $input) {
      posDeploymentDetails {
        id
      }
      opportunityId
    }
  }
`

export const GET_REVISIT_COUNTS = gql`
  query GetLeadCounts($input: getLeadCountsInput!) {
    getLeadCounts(input: $input) {
      totalLeadsCount
      myOpenLeadsCount
      openAssignedLeadsCount
      rescheduledLeadsCount
      resolvedLeadsCount
      closedIncompleteLeadsCount
    }
  }
`

export const VALIDATE_POS_ID = gql`
  query validateProductItem($input: ValidateProductItemInput!) {
    validateProductItem(input: $input) {
      productsRequiredAndInventoryDetails {
        productName
        productType
        mandatory
        childAsset
        parentAsset
        inventoryDetailsList {
          id
          srno
          pqrId
          pqrSrno
          productItemNumber
        }
      }
    }
  }
`

export const EXTRACT_MCCS_BY_DOCUMENTS = gql`
  query ExtractMccsByDocuments($input: ExtractMCCsByDocumentsInput!) {
    extractMccsByDocuments(input: $input) {
      mccs {
        mccCode
        confidenceScore
      }
    }
  }
`
export const SEARCH_USER = gql`
  query SearchUser($input: SearchUserInput) {
    searchUser(input: $input) {
      users {
        id
        mdpUserId
        email
        crmUserId
        name
        street
        city
        createdBySource
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        profileId
        isActive
        hasCrmLicence
        internalCoordinatorId
        employeeId
        managerId
        salesManagerId
        mdpProfileId
        managerEmpId
        managerName
        managerEmail
        systemIntegrationUser
        crmIdMLU
        locationId
        phoneNo
        userType
        empIdWithAgency
        nameOfAgency
        internalCoordinatorEmpCode
        isMasterUser
        profileName
      }
      page
      size
      totalElements
      totalPages
    }
  }
`
export const GET_PRODUCTS_VIEW_BY_OPPORTUNITY = gql`
  query GetProductsViewByOpportunity($input: GetProductsViewByOpportunityInput) {
    getProductsViewByOpportunity(input: $input) {
      name
      vasDetails {
        name
        isAggregator
        acquirer
        vasReferenceId
        productId
      }
      advanceMonth
      posName
      quantity
      planId
      productImageUrl
      posReferenceId
      edcItemNumber
      isPaymentDevice
    }
  }
`

export const GET_PRODUCT_SHORT_BY_PLAN_ID = gql`
  query GetProductsViewByPlan($input: GetProductsViewByPlanInput) {
    getProductsViewByPlan(input: $input) {
      id
      sfReferenceId
      name
      mccList
      pricingType
      vasProduct {
        id
        name
        mdrfees {
          id
          sfReferenceId
          name
          slabList
          value
        }
      }
    }
  }
`
export const GET_FILTERED_MDR_BY_SF_REFERENCE_ID = gql`
  query FilterBySfReferenceId($input: JSON) {
    filterBySfReferenceId(input: $input)
  }
`
export const GET_ALL_ISSUERS = gql`
  query GetAllIssuers {
    getAllIssuers {
      issuerName
      issuerExternalId
      issuerAggregatorName
      issuerType
      status
    }
  }
`
export const GET_PLAN_VIEW_BY_HARD_POS = gql`
  query GetPlanViewByHardPos($input: PlanViewByHardPosInput!) {
    getPlanViewByHardPos(input: $input) {
      plans {
        planType
        planSubTypes {
          planName
          planSubType
          advanceMonth
          acquirerList
          secondaryAcquirerList
          plandid
        }
      }
    }
  }
`
export const GENERATE_CKYC_OTP = gql`
  query CKYCGetOtp($input: CKYCGetOtpInput!) {
    ckycGetOtp(input: $input) {
      requestId
      vendorRefId
      result {
        message
      }
    }
  }
`

export const VALIDATE_CKYC_OTP = gql`
  query CKYCValidateOtp($input: CKYCValidateOtpInput!) {
    ckycValidateOtp(input: $input) {
      requestId

      result {
        type

        personalDetails {
          constitutionType
          accountHolderType
          ckycId

          personalInfo {
            firstName
            fullName
            lastName
            middleName
            prefix
          }

          prefix
          firstName
          middleName
          lastName
          fullName

          maidenInfo {
            maidenFirstName
            maidenFullName
            maidenLastName
            maidenMiddleName
            maidenPrefix
          }

          maidenPrefix
          maidenFirstName
          maidenMiddleName
          maidenLastName
          maidenFullName

          fatherSpouseInfo {
            fatherSpouseFirstName
            fatherSpouseFlag
            fatherSpouseFullName
            fatherSpouseLastName
            fatherSpouseMiddleName
            fatherSpousePrefix
          }

          fatherSpouseFlag
          fatherSpousePrefix
          fatherSpouseFirstName
          fatherSpouseMiddleName
          fatherSpouseLastName
          fatherSpouseFullName

          motherInfo {
            motherFirstName
            motherLastName
            motherFullName
            motherMiddleName
            motherPrefix
          }

          motherPrefix
          motherFirstName
          motherMiddleName
          motherLastName
          motherFullName

          gender
          dob
          pan

          permanentAddress {
            line1
            line2
            line3
            city
            district
            state
            country
            pincode
          }

          correspondence {
            line1
            line2
            line3
            city
            district
            state
            country
            pincode
          }

          permPoa
          permCorresSame
          corresPoa
          stdCode
          telephoneNumber
          officeStdCode
          officeTelephoneNumber
          mobileCode
          mobileNumber
          email
          remarks
          declarationDate
          declarationPlace
          kycDate
          typeOfDocSubmitted
          kycVerificationName
          kycVerificationDesignation
          kycVerificationBranch
          kycVerificationEmpCode
          organisationName
          organisationCode
        }

        identityDetails {
          imageInfo {
            branchCode
            globalOrLocalImage
            image
            imageExtension
            imageType
          }
          number
          type
          verificationStatus
        }

        relatedPersonDetails {
          addDeleteFlag
          ckycId
          corresPoa

          correspondence {
            city
            country
            district
            line1
            line2
            line3
            pincode
            state
          }

          declarationDate
          declarationPlace
          dinNumber

          disabilityInfo {
            flag
            percentage
            type
            udidNo
          }

          dlNumber
          dob
          ekycAuthentication
          email

          fatherSpouseInfo {
            fatherSpouseFirstName
            fatherSpouseFlag
            fatherSpouseFullName
            fatherSpouseLastName
            fatherSpouseMiddleName
            fatherSpousePrefix
          }

          form60Submitted
          gender
          imageData
          imageType
          kycDate
          kycVerificationBranch
          kycVerificationDate
          kycVerificationDesignation
          kycVerificationEmpCode
          kycVerificationName

          maidenInfo {
            maidenFirstName
            maidenFullName
            maidenLastName
            maidenMiddleName
            maidenPrefix
          }

          mobileCode
          mobileNumber

          motherInfo {
            motherFirstName
            motherFullName
            motherLastName
            motherMiddleName
            motherPrefix
          }

          nationality
          nprId
          nregaId
          officeStdCode
          officeTelephoneNumber
          offlineVerificationAadhaar
          organisationCode
          organisationName
          pan
          passport
          passportExpiry

          permanentAddress {
            city
            country
            district
            line1
            line2
            line3
            pincode
            state
          }

          permCorresSame
          permPoa
          permPoiImageData
          permPoiImageType

          personalInfo {
            firstName
            lastName
            fullName
            middleName
            prefix
          }

          possessionOfAadhaar
          relatedPersonTypeOthers
          relationType
          relTypeOthers
          remarks
          stdCode
          telephoneNumber
          typeOfDocSubmitted
          voterId
        }

        imageDetails {
          imageExtension
          imageType
          globalOrLocalImage
          branchCode
          image
        }

        dataFromCersai
        decryptedDataFromCersai
      }
    }
  }
`

export const SEARCH_CKYC_DETAILS = gql`
  query ckycSearch($input: CKYCSearchInput!) {
    ckycSearch(input: $input) {
      requestId
      vendorRefId
      found

      result {
        ckycNo
        ckycRefId
        name
        fatherName
        age
        image
        kycDate
        updatedOn
        remarks
        type

        idList {
          type
          available
        }
      }

      internalMatch {
        ckycId
        custType
        found
        recordId
        retrievedAt
      }
    }
  }
`

export const CKYC_DOWNLOAD = gql`
  query CKYCDownload($input: CKYCDownloadInput!) {
    ckycDownload(input: $input) {
      requestId
      vendorRefId
      result {
        dataFromCersai
        decryptedDataFromCersai
        type

        identityDetails {
          number
          type
        }

        imageDetails {
          branchCode
          globalOrLocalImage
          image
          imageExtension
          imageType
        }

        personalDetails {
          ckycId
          constiTypeOthers
          constitutionType

          correspondence {
            city
            country
            district
            line1
            line2
            line3
            pincode
            state
          }
          permanentAddress {
            city
            country
            district
            line1
            line2
            line3
            pincode
            state
          }

          corresPoa
          countryOfIncorporation
          dataFromCersai
          dateOfCommencement
          declarationDate
          declarationPlace
          decryptedDataFromCersai
          dob
          email
          equivalentIssuingCountry
          faxNo
          fullName
          gstNumber
          identityVerificationDoc
          kycDate
          kycVerificationBranch
          kycVerificationDesignation
          kycVerificationEmpCode
          kycVerificationName
          officeStdCode
          officeTelephoneNumber
          organisationCode
          organisationName
          pan
          permCorresSame
          permPoa
          permPoaOthers
          placeOfIncorporation
          proofAddress
          remarks
          stdCode
          typeOfDocSubmitted
        }

        relatedPersonDetails {
          addDeleteFlag
          ckycId
          corresPoa
          declarationDate
          declarationPlace
          dinNumber
          dlNumber
          dob
          ekycAuthentication
          email
          form60Submitted
          gender
          imageData
          imageType
          kycDate
          kycVerificationBranch
          kycVerificationDate
          kycVerificationDesignation
          kycVerificationEmpCode
          kycVerificationName
          mobileCode
          mobileNumber
          nationality
          nprId
          nregaId
          officeStdCode
          officeTelephoneNumber
          offlineVerificationAadhaar
          organisationCode
          organisationName
          pan
          passport
          passportExpiry
          permCorresSame
          permPoa
          permPoiImageData
          permPoiImageType
          possessionOfAadhaar
          relatedPersonTypeOthers
          relationType
          relTypeOthers
          remarks
          stdCode
          telephoneNumber
          typeOfDocSubmitted
          voterId
        }
      }
    }
  }
`

export const GET_CKYC_BY_PAN = gql`
  query CKYCGetMerchantPAN($input: CKYCMerchantPANInput!) {
    ckycGetMerchantPAN(input: $input) {
      requestId
      vendorRefId
      result {
        type
        relatedPersonDetails {
          addDeleteFlag
          ckycId
          corresPoa
          declarationDate
          declarationPlace
          dinNumber
          dlNumber
          dob
          ekycAuthentication
          form60Submitted
          gender
          imageType
          kycDate
          mobileCode
          mobileNumber

          nationality
          nprId
          nregaId
          officeStdCode
          officeTelephoneNumber
          offlineVerificationAadhaar
          organisationCode
          organisationName
          pan
          passport
          passportExpiry
          permanentAddress {
            city
            country
            district
            line1
            line2
            line3
            pincode
            state
          }
          permCorresSame
          permPoa
          permPoiImageType
          personalInfo {
            firstName
            lastName
            fullName
            middleName
            prefix
          }
          possessionOfAadhaar
          relatedPersonTypeOthers
          relationType
          relTypeOthers
          remarks
          stdCode
          telephoneNumber
          typeOfDocSubmitted
          voterId
        }
      }
    }
  }
`

export const GET_PLANIDS_FROM_OLIS = gql`
  query Query($input: GetAllOLIInput) {
    getAllOLIs(input: $input) {
      id
      planId
      name
    }
  }
`
export const GET_DEPLOYMENT_ASSETS_STATUS = gql`
  query deploymentRequestByAssetId($input: GetDeploymentAssetInput!) {
    deploymentRequestByAssetId(input: $input) {
      id
      assetName
      posId
      workFlowState
      status
      isProductsConsumed
    }
  }
`

export const SEARCH_CKYC_DETAILS_V2 = gql`
  query ckycSearch($input: CKYCSearchInput!) {
    ckycSearch(input: $input) {
      requestId
      vendorRefId
      found
      result {
        individual {
          ckycNo
          ckycRefId
          name
          fatherName
          age
          image
          kycDate
          updatedOn
          remarks
          type
          constitutionType
          placeOfIncorporation
          idList {
            type
            available
          }
        }
        nonIndividual {
          ckycNo
          ckycRefId
          name
          fatherName
          age
          image
          kycDate
          updatedOn
          remarks
          type
          constitutionType
          placeOfIncorporation
          idList {
            type
            available
          }
        }
      }
      internalMatch {
        ckycId
        custType
        found
        recordId
        retrievedAt
      }
    }
  }
`

export const GET_ALL_VAS_PLANS = gql`
  query Query($input: getAllPlansInput) {
    getAllPlans(input: $input) {
      plans {
        id
        sfReferenceId
        name
        acquirerList
      }
    }
  }
`

export const GET_DEPLOYMENT_STORES_BY_MERCHANT_ID = gql`
  query DeploymentStoresByMerchantId($input: DeploymentStoreDetailsInput!) {
    deploymentStoresByMerchantId(input: $input) {
      stores {
        id
        name
        address {
          cityName
          stateName
        }
        pcId
      }
    }
  }
`

export const GET_DEPLOYMENT_STORES_BY_ACCOUNT_ID = gql`
  query DeploymentStores($input: DeploymentStoresInput!) {
    deploymentStores(input: $input) {
      id
      name
      storeCode
    }
  }
`

export const GET_LIVE_POS_BY_STORE = gql`
  query GetPOS($input: GetPOSInput!) {
    getPOS(input: $input) {
      posDetails {
        id
        name
        posId
        status
        storeId
        hardwareLiveDate
      }
    }
  }
`

export const GET_ALL_POS_VAS = gql`
  query GetAllPosVas($input: GetAllPosVasInput!) {
    getAllPosVas(input: $input) {
      posCount
      posVasWrapperList {
        vasCount
        pos {
          id
          name
          posId
          storeId
          isEligibleForThisVasActivation
        }
        vasList {
          name
          acquirerIdList
        }
      }
    }
  }
`

export const GET_OPPORTUNITY_CSE_L1 = gql`
  query Opportunity($input: GetOpportunityInput!) {
    opportunity(input: $input) {
      enableServicenow
      caseId
      purchaseOrder {
        poActivationStatus
      }
    }
  }
`

export const GET_ALL_PLANS_FOR_ACCESSORY = gql`
  query GetAllPlansForAccessory($input: PlanViewByHardPosInput!) {
    getAllPlansForAccessory(input: $input) {
      plans {
        planType
        planSubTypes {
          planName
          planSubType
          advanceMonth
          acquirerList
          secondaryAcquirerList
          plandid
        }
      }
    }
  }
`

export const GET_ALL_ACCESSORY_PRODUCTS = gql`
  query GetAllAccessoryProducts($input: GetAllAccessoryProductsInput) {
    getAllAccessoryProducts(input: $input) {
      accessoryProduct {
        id
        sfReferenceId
        name
        isActive
        edcItemNumber
        edcType
        createdOn
        modifiedOn
        isPaymentDevice
        downstreamId
        productImageUrl
        category
        subCategory
      }
    }
  }
`

export const GET_PRODUCTS_VIEW_FOR_ACCESSORY = gql`
  query GetProductsViewForAccessory($input: GetProductsViewForAccessoryInput) {
    getProductsViewForAccessory(input: $input) {
      id
      sfReferenceId
      name
      description
      salesCategory
      mccList
      advanceMonth
      advanceMonthEditable
      customAdvancedMonth
      pricingType
      nbsId
      vasReferenceId
      customAdvancedMonth
      pricingType
      planId
      productType
      recommended
      fees {
        id
        feemappingreferenceid
        sfReferenceId
        name
        fee
        customValue
        pricingType
        feeType
        unitOfMeasurement
        value
        minValue
        maxValue
        frequency
        downStreamNBSId
        entityType
        navFeeCode
        subscription
        createdOn
        active
        customValue
        pricingType
        feemappingreferenceid
        editable
      }
      posProduct {
        id
        sfReferenceId
        name
        feeMappingReference
        productImageUrl
        posType
        hardwareModel
        downstreamPosId
        edcType
        edcItemNumber
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        active
      }
      feeMappingReference
      vasProduct {
        id
        sfReferenceId
        downstreamVasId
        name
        aggregatorProgramId
        aggregatorProgramName
        feeMappingReference
        bankDetails
        settlementCycle
        modeOfPay
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        active
        pg
        accessory
        mdrfees {
          id
          sfReferenceId
          name
          cardSegment
          cardSegmentId
          instrumentType
          slabList
          value
          issuer
          insurancePartner
          insuranceSubPartner
          vasReference
          insuranceIssuer
          insuranceProvider
          createdOn
          modifiedOn
          createdBy
          modifiedBy
          active
          mdrType
          pricingType
          enabled
          merchantSplit
          insurerSplit
          pinelabsSplit
          editable
        }
      }
      eligibleFor3PUser
      category
      businessSubCategory
      quantity
      sortOrder
      createdOn
      modifiedOn
      createdBy
      modifiedBy
      active
      aggregator
      acquirer
      accessoryReferenceId
      accessoryProduct {
        id
        sfReferenceId
        name
        isActive
        edcItemNumber
        edcType
        createdOn
        modifiedOn
      }
    }
  }
`
